import clsx from 'clsx'
import { ComponentType, forwardRef } from 'react'
import styles from './Button.module.css'

type Falsy = false | 0 | '' | null | undefined

const iconSize = {
  xsmall: 'h-3 w-3',
  small: 'h-4 w-4',
  medium: 'h-4 w-4',
}

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'contained' | 'outlined' | 'text'
  color?: 'primary' | 'secondary' | 'neutral' | 'error' | 'success'
  size?: 'xsmall' | 'small' | 'medium'
  StartIcon?: ComponentType<{ className?: string }> | Falsy
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      color = 'primary',
      variant = 'contained',
      size = 'medium',
      className,
      StartIcon,
      ...rest
    },
    ref
  ) => {
    return (
      <button
        type='button'
        {...rest}
        ref={ref}
        className={clsx(className, styles.base, styles[`${variant}_${color}`], styles[size])}
      >
        {!!StartIcon && <StartIcon className={iconSize[size]} />}
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
export default Button
